import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function DashboardReport(props) {
  const { xaxis, data } = props.chData;
  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    const reData = [];

    Object.keys(data).forEach((dt) => {
      const firstname = dt.slice(0, dt.length - 5);
      const lastname = dt.slice(dt.length - 5);
      const name = `${firstname[0].toUpperCase()}${firstname.slice(1)} ${lastname[0].toUpperCase()}${lastname.slice(1)}`;

      reData.push({
        name,
        data: data[dt],
      });
    });

    setReportData(reData);
    setLoading(false);

    return () => setReportData([]);
  }, [data]);

  const options = {
    chart: {
      type: "column",
    },
    accessibility: {
    enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      symbolHeight: 11,
      symbolWidth: 11,
      symbolRadius: 0,
    },
    title: {
      text: "",
    },
    xAxis: {
      min: 0,
      categories: xaxis,
    },
    yAxis: {
      min: 1,
      title: {
        text: "",
      },
    },
    lang: {
      noData: "No data found",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
      series: {
        pointWidth: 10,
        pointPadding: 0,
        groupPadding: 0.2,
        gapSize: 1,
      },
    },
    series: reportData,
  };

  if (loading) return <div style={{ padding: "10px" }}>Loading chart...</div>;

  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </>
  );
}
